import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { Col, Grid, Row } from "antd";

const { useBreakpoint } = Grid;

export function ServiceJ1SBackground({ what_is_jet_1_suites = {} }) {
	const screens = useBreakpoint();
	return (
		<Container>
			<Row align="top" gutter={[12, 12]}>
				<Col xxl={8} xl={10} md={10} sm={12} xs={24}>
					<WrapperMain className={`${"animate__animated animate__fadeInUp"}`}>
						<RATypography variant={screens?.xs ? "h4" : "h2"} whiteSpace="pre-wrap">
							{what_is_jet_1_suites?.title || ""}
						</RATypography>
					</WrapperMain>
				</Col>
				<Col xxl={16} xl={14} md={14} sm={12} xs={24}>
					<RATypography variant="body3" color="#595959">
						{what_is_jet_1_suites?.description || ""}
					</RATypography>
				</Col>
			</Row>
		</Container>
	);
}

const Container = styled.div`
	width: "100%";
	position: "relative";
	padding: 80px 0;
	max-width: 1442px;
	width: 100%;
	@media (max-width: 991px) {
		padding: 60px 0;
	}
	@media (max-width: 767px) {
		padding: 40px 0;
	}
	@media (max-width: 575px) {
		padding: 0px 0;
	}
`;
const WrapperMain = styled.div`
	padding: 4px 12px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
